#import "~/graphql/fragments/PaginatorInfo.graphql"
#import "~/graphql/fragments/VideoIndex.graphql"

query Videos(
    $limit: Int = 20
    $page: Int = 1
    $featured: Boolean
    $isCaseOfTheMonth: Boolean
    $specialisation: ID
    $inMyInterests: Boolean
    $excludeVideoIds: [ID!]
) {
    videos(
        first: $limit
        page: $page
        isFeatured: $featured
        isCaseOfTheMonth: $isCaseOfTheMonth
        specialisation: $specialisation
        withinYourSpecialisation: $inMyInterests
        exclude: $excludeVideoIds,
        isPublished: true,
    ) {
        data {
            ...VideoIndex
        }

        paginatorInfo {
            ...PaginatorInfo
        }
    }
}
